import { render, staticRenderFns } from "./ConfirmePixView.vue?vue&type=template&id=6cfcb387&scoped=true&"
import script from "./ConfirmePixView.vue?vue&type=script&lang=js&"
export * from "./ConfirmePixView.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmePixView.vue?vue&type=style&index=0&id=6cfcb387&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfcb387",
  null
  
)

export default component.exports